import { css } from "@emotion/react"
import { useTheme } from "@mui/material"

export const useStyles = () => {
  const theme = useTheme()
  return {
    headerRoot: css`
      width: 100%;

      ${theme.breakpoints.down("md")} {
        padding: 0;
      }
    `,
    row: css`
      display: flex;
      flex-wrap: wrap;
    `,
    box: css`
      flex-direction: column;
      overflow: hidden;
    `,
    title: css`
      display: block;
      margin-bottom: ${theme.spacing(1)};

      ${theme.breakpoints.down("md")} {
        font-size: 0.75rem;
      }
    `,
    value: css`
      ${theme.breakpoints.down("md")} {
        font-size: ${theme.typography.body2.fontSize};
        font-weight: ${theme.typography.body2.fontWeight};
        letter-spacing: ${theme.typography.body2.letterSpacing};
      }
    `,
    table: css`
      display: block;
      ${theme.breakpoints.down("lg")} {
        display: none;
      }
    `,
    cards: css`
      display: none;
      margin-top: ${theme.spacing(4)};

      ${theme.breakpoints.down("lg")} {
        display: block;
      }
    `,
  }
}
